import { AddOutlined, DownloadOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CustomButton, FilterBar, TableData } from "components";
import { errorAlert } from "helpers/alerts";
import { currencyFormatter, downloadFile } from "helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import { downloadAbonosService, getAbonosService } from "services/abonos/abonosService";

const AbonosHistorialScreen = () => {
  const dispatch = useDispatch();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({});
  useEffect(() => {
    dispatch(setTitle("Abonos"));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = async (data) => {
    setLoading(true);
    setFilters(data);
    getAbonosService(data)
      .then((result) => setList(result))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };
  const handlerDownload = () => {
    setLoading(true);
    downloadAbonosService(filters)
      .then((data) => downloadFile(data, "Reporte Abonos.xlsx"))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };
  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showButton={false}
        showTitle={false}
        defaultValues={{
          date: [moment().subtract(1, "month").toDate(), moment().toDate()],
        }}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            type: "select",
            name: "status",
            label: "Estado",
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "Aplicado", name: "Aplicado" },
              { id: "Descartado", name: "Descartado" },
            ],
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          dataRows={list}
          dataTitle={[
            "Banco Origen",
            "Banco Destino",
            "Importe",
            "Bolsa destino",
            "Referencia",
            "Deposito",
            "Estado",
          ]}
          formatter={(row) => [
            row?.bankOrigin || "-",
            row?.bankDestination?.bank || "-",
            row?.amount ? currencyFormatter.format(row?.amount || 0) : "-",
            row?.bagType || "-",
            row?.reference || "-",
            {
              type: "text",
              value: row.date ? moment(row.date).format("DD/MM/YYYY HH:mm:ss") : "",
              title: `Hora de envío de notificación: ${moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss")}`,
            },
            row?.status || "-",
          ]}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={<DownloadOutlined />}
              key={"downloadAbonos"}
              name={"Descargar"}
              loading={loading}
              click={handlerDownload}
            />
          ].filter(Boolean)}
        />
      </Box>
    </>
  );
};

export default AbonosHistorialScreen;
